import { PaymentMethod } from './payment-method.model';
import { PaymentMethodType } from '../enums/payment-method';

export class CostCenter extends PaymentMethod {
  public cost_center_id: string;
  public label: string;
  public business_area: any;
  public company_code: any;
  public account_number: any;
  public order_number: any;
  public allocation: any;
  public employee_id: string;
  public limit_per_po: number;
  public order_id?: number; // order id is required to validate cost center against purchase limit

  public type = PaymentMethodType.CostCenter; // type of payment method

  public first_name: string;
  public last_name: string;

  public verified: boolean; // true if cost center has been verified

  constructor(data: any) {
    super(data);
    if (typeof data === 'string') {
      data = JSON.parse(data);
    }
    if (data) {
      Object.assign(this, data);
    }
  }

  public getLongAccount() {
    const la = [
      this.company_code || ' ',
      this.business_area || ' ',
      this.account_number || ' ',
      this.cost_center_id || ' ',
    ];

    if (this.order_number) {
      la.push(this.order_number);
    }
    if (this.allocation) {
      la.push(this.allocation);
    }

    return la.join('-');
  }

  isAccount(): boolean {
    return true;
  }

  isCard(): boolean {
    return false;
  }
}
